function dispatchThemeSectionEvents(sectionRootEl) {
  // 1) Dein eigenes Event (falls du später doch mal brauchst)
  document.dispatchEvent(new CustomEvent("section:mounted", { detail: { section: sectionRootEl } }));

  // 2) Shopify-ähnliche Events (viele Themes hängen daran)
  const detail = { sectionId: sectionRootEl.id?.replace(/^shopify-section-/, "") };

  document.dispatchEvent(new CustomEvent("shopify:section:load", { detail }));
  document.dispatchEvent(new CustomEvent("shopify:section:reorder", { detail }));
  document.dispatchEvent(new CustomEvent("shopify:section:select", { detail }));
}

function reexecuteInlineScripts(root) {
  // Wenn im gerenderten HTML <script>…</script> drin ist, wird es durch innerHTML NICHT ausgeführt.
  // Das ist generisch und schadet nicht (läuft nur, wenn scripts vorhanden sind).
  root.querySelectorAll("script").forEach((oldScript) => {
    const s = document.createElement("script");
    // Attribute kopieren
    for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value);
    s.text = oldScript.textContent || "";
    oldScript.replaceWith(s);
  });
}

async function mountShopifySection(el) {
  const sectionId = el.dataset.sectionId;
  if (!sectionId || el.dataset.mounted) return;
  el.dataset.mounted = "true";

  const sourcePath = el.dataset.sourcePath || window.location.pathname;
  const url = `${sourcePath}?sections=${encodeURIComponent(sectionId)}`;

  try {
    const res = await fetch(url, { credentials: "same-origin" });
    const json = await res.json();
    const html = json[sectionId];
    if (!html) return;

    // Sauber in DOM umwandeln
    const tpl = document.createElement("template");
    tpl.innerHTML = html.trim();

    // Inhalte ersetzen
    el.innerHTML = "";
    el.appendChild(tpl.content);

    // Inline Scripts (falls vorhanden) ausführen
    reexecuteInlineScripts(el);

    // Shopify-Section-Root(s) finden und Events dispatchen
    const roots = el.querySelectorAll('[id^="shopify-section-"]');
    if (roots.length) {
      roots.forEach(dispatchThemeSectionEvents);
    } else {
      // Fallback: wenn kein root gefunden wird, wenigstens ein generisches Event feuern
      document.dispatchEvent(new CustomEvent("section:mounted", { detail: { section: el } }));
    }
  } catch (e) {
    console.error("Section mount failed:", e);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-section-mount][data-section-id]").forEach(mountShopifySection);
});
